const punctuationRegex = /[.!?]$/;

export const formatMessageFromResponseErrorData = (
  responseErrorData: any,
): string => {
  // handle formatted error responses
  if (
    responseErrorData?.message &&
    typeof responseErrorData.message === "string"
  ) {
    let errorMessage = responseErrorData.message;
    // capitalize the first character of the message (as long as the error message is a string of length 2)
    if (errorMessage.length - 1) {
      errorMessage =
        errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
    }
    // add punctuation if missing
    if (!punctuationRegex.test(errorMessage)) {
      errorMessage = `${errorMessage}.`;
    }
    // add error code info if provided
    if (responseErrorData.code || responseErrorData.code === 0) {
      errorMessage = `${errorMessage} Error code: ${responseErrorData.code}`;
    }
    return errorMessage;
  }

  // handle generic error responses with only text in the response body (e.g. Unauthorized responses from the Frontier API due to missing or expired token)
  if (
    !!responseErrorData &&
    typeof responseErrorData !== "object" &&
    responseErrorData !== ""
  ) {
    return responseErrorData;
  }

  return "An unknown error has occurred. Please try again later.";
};
